// CartSidebar.js - Updated to use cart store
import React, { useEffect } from "react";
import classNames from "classnames/bind";
import styles from "./CartSidebar.module.scss";
import { useCartSidebarStore } from "../../stores/Cart/cartSidebarStore";
import useCartStore from "../../stores/Cart/useCartStore"; // Import cart store
import {
  CartHeader,
  CartFooter,
  CartItem,
  CartEmptyState,
} from "../../components/Cart";
import { LoaderCircle } from "lucide-react";
import useTranslations from "../../hooks/useTranslations";

const cx = classNames.bind(styles);

const ShoppingCartSidebar = () => {
  // Sidebar store
  const isOpen = useCartSidebarStore((state) => state.isOpen);
  const close = useCartSidebarStore((state) => state.close);
  const currentTranslations = useTranslations();
  // Cart store
  const {
    cartItems,
    cartTotals,
    isLoading,
    error,
    updateQuantity,
    removeFromCart,
    // getTotalItems,
    isEmpty,
    clearError,
  } = useCartStore();

  // Clear errors when sidebar closes
  useEffect(() => {
    if (!isOpen) {
      clearError();
    }
  }, [isOpen, clearError]);

  const handleUpdateQuantity = async (cartItemKey, newQuantity) => {
    const result = await updateQuantity(cartItemKey, newQuantity);
    if (!result.success) {
      console.error("Failed to update quantity:", result.error);
    }
  };

  const handleRemoveItem = async (cartItemKey) => {
    const result = await removeFromCart(cartItemKey);
    if (!result.success) {
      console.error("Failed to remove item:", result.error);
    }
  };

 

  return (
    <>
      {/* Sidebar */}
      <div className={cx("cart-sidebar", { "cart-sidebar--open": isOpen })}>
        <CartHeader onClose={close} title={currentTranslations?.Cart?.title} />

        <div className={cx("cart-content")}>
          {/* Display error if any */}
          {error && (
            <div className={cx("cart-error")}>
              <p style={{ color: "red", padding: "10px", fontSize: "14px" }}>
                {error}
              </p>
            </div>
          )}

          {isLoading ? (
            <div className={cx("cart-loading")}>
              <LoaderCircle size={42} className={cx("loader")} />
            </div>
          ) : isEmpty() ? (
            <CartEmptyState message={currentTranslations?.Cart?.empty} />
          ) : (
            <div className={cx("cart-items")}>
              {cartItems.map((item) => (
                <CartItem
                  key={`${item.id}-${item.cart_item_key}`}
                  item={item}
                  onUpdateQuantity={handleUpdateQuantity}
                  onRemove={handleRemoveItem}
                />
              ))}
            </div>
          )}
        </div>

        <CartFooter
          // totalItems={getTotalItems()}
          totalPrice={cartTotals.total}
          disabled={isEmpty() || isLoading}
          buttonText={currentTranslations?.Cart?.checkout}
        />
      </div>
    </>
  );
};

export default ShoppingCartSidebar;
